import { formatDistanceToNow } from "date-fns";

/* "4 days ago". Shared: two screens age a timestamp this way — a tracked buyer's changes on the Partner Program, and a support ticket on Help & Support — and... */
export const relativeTime = (timestamp) => {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return formatDistanceToNow(d, { addSuffix: true });
  } catch {
    /* formatDistanceToNow throws on values it cannot describe. */
    return "";
  }
};

export default relativeTime;
